import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LoadingController} from '@ionic/angular';
import 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AppService {

  // apiUrl = 'http://perutions.com/2021/resilink/apis/index.php/';
  //apiUrl = 'http://perutions.com/beta/cinematheatrebooking/index.php/';
  //apiUrl = 'https://demo.perutions.com/cinephile/api/index.php/';
  // apiUrl = 'https://cinephiledigital.com/manage/api/index.php/';
  // apiUrl /index.php/'
 apiUrl = 'https://cqzentertainments.com/manage/api/index.php/'
// apiUrl = 'http://localhost/manage/api/index.php/'  
  constructor(public http: HttpClient, public loadingCtrl: LoadingController) { }



  userLogin(params) {

    return new Promise(resolve => {
      this.http.post(this.apiUrl+'/applogin',params).subscribe((data: any) => {
        resolve(data);
      }, err => {
        console.log('error'+err);
      });
    });
  }


  // async userLogins(params) {
  //   const loader = await this.loadingCtrl.create({
  //     content: 'Please wait...',
  //     spinner: 'circles'
  //   });
  //   await loader.present();
  //
  //   this.http.post(this.apiUrl+'/applogin',params).subscribe((data: any) => {
  //
  //     resolve(data);
  //     loader.dismiss();
  //   }, err => {
  //     console.log('error' + err);
  //     loader.dismiss();
  //   });
  // }

  get(url: string) {
    return new Promise(resolve => {
      this.http.get(this.apiUrl+url).subscribe((data: any) => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });

  }

  post(url: string, payload: object) {
    return new Promise(resolve => {
      this.http.post(this.apiUrl+url, payload).subscribe((data: any) => {
        resolve(data);
      }, err => {
        resolve(err);
      });
    });
  }

  addMovieReview(payload: object) {
    return this.post('addreview', payload);
  }

  getUserMovieReview(userId: any, movieId?: any) {
    return this.post('getuserreview', { user_id: userId, movie_id: movieId });
  }

  postw(url: string, payload: object) {
    return new Promise(resolve => {
      this.http.post(this.apiUrl+url, payload).subscribe((data: any) => {
        resolve(data);
      }, err => {
        resolve(err);
      });
    });
  }

  postLogin(url: string, payload: object) {

    return new Promise(resolve => {
      this.http.post(this.apiUrl+url, payload).subscribe((data: any) => {
        resolve(data);
      }, err => {
        resolve(err);
      });
    });
  }

  recharge(url: string, payload: object) {
    return new Promise((resolve) => {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'accept': '*/*',
        'Client-Id':'5WKhvPkdMz9EbNvvSSUQIA==',
        'Client-Secret':'mWrpVcMf/fsuM0QTUkxfc4TS958Zn9xxg0PGilDRUbE=',
        'Authorization':'Basic ' + btoa("AKSHAY:enter@1234")
      });
      const requestOptions = { headers: headers };
      this.http.post(url, payload, requestOptions).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          resolve(err);
        }
      );
    });
  }

  billkadealFetch(payload: object) {
    return this.post('billkadeal_fetch', payload);
  }

  billkadealPay(payload: object) {
    return this.post('billkadeal_pay', payload);
  }

  billkadealStatus(payload: object) {
    return this.post('billkadeal_status', payload);
  }

}
